import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { shape, bool, instanceOf, func, number, string } from 'prop-types';
import cloneDeep from 'lodash/cloneDeep';
import isEmpty from 'lodash/isEmpty';
import {
  getDeDefinitions,
  resetCreatAccountForm,
} from '../../actions/contractAdminActions';
import CATableHeader from './CATableHeader';
import CATableBody from './CATableBody';
import addNewIcon from '../../images/contract-admin-icons/list_alt-24px.svg';
import CASearch from './CASearch';
import { useDispatch } from '../../components/common/react-redux-hooks';
import BulkStatusUpdateModal from './BulkStatusUpdateModal';

const ContractAdminView = ({
  definition,
  getDeDefinitions,
  accountId,
  addNewBtn,
}) => {
  const [isAllChecked, setIsAllChecked] = useState(false);
  const [selectAllClicked, setSelectAllClicked] = useState(false);
  const [rowCheckboxClicked, setRowCheckboxClicked] = useState(false);
  const [definitionData, setDefinitionData] = useState(cloneDeep(definition));
  const [disableChangeStatus, setDisableChangeStatus] = useState(true);
  const [showBulkStatusUpdateModal, setShowBulkStatusUpdateModal] = useState(
    false
  );
  const dispatch = useDispatch();
  // const [query, updateQuery] = useState(queryParam);
  useEffect(() => {
    const query = {
      searchPhrase: '',
      searchBy: 'account',
      pageNumber: 1,
      pageSize: 10,
      sortColumn: 'account_accountName',
      sortOrder: 'desc',
    };
    getDeDefinitions(accountId, query);
    // getDeDefinitions(accountId, definition.query);
  }, []);
  useEffect(() => {
    if (rowCheckboxClicked) {
      setDefinitionData(definitionData);
      setRowCheckboxClicked(false);
    }
  }, [rowCheckboxClicked]);
  useEffect(() => {
    setDefinitionData(cloneDeep(definition));
  }, [definition.data, definition.query]);
  useEffect(() => {
    if (selectAllClicked && definitionData.data) {
      definitionData.data.map(item => {
        item.isChecked = isAllChecked;
        return item;
      });
    }
  }, [isAllChecked]);

  const _updateQueryParams = (value, queryAttr, isLoadMore = false) => {
    let updatedQuery = { ...definition.query };
    if (queryAttr === 'sort') {
      updatedQuery = {
        ...updatedQuery,
        sortColumn: value.sortColumn,
        sortOrder: value.sortOrder,
        pageNumber: 1,
      };
    } else if (queryAttr === 'searchPhrase') {
      updatedQuery = {
        ...updatedQuery,
        sortColumn: 'account_accountName',
        sortOrder: 'desc',
        [queryAttr]: encodeURIComponent(value),
        pageNumber: 1,
      };
    } else if (queryAttr === 'searchBy') {
      updatedQuery = {
        ...updatedQuery,
        searchBy: value,
        pageNumber: 1,
      };
    } else {
      updatedQuery = {
        ...updatedQuery,
        [queryAttr]: value,
      };
    }
    if (!isAllChecked) {
      setDisableChangeStatus(true);
    }
    getDeDefinitions(accountId, updatedQuery, isLoadMore, isAllChecked);
  };

  const loadItems = page => {
    _updateQueryParams(page, 'pageNumber', true);
  };

  const addNew = () => {
    addNewBtn();
    dispatch(resetCreatAccountForm());
  };
  const _toggleCheckboxState = isCheckboxSelected => {
    setIsAllChecked(isCheckboxSelected);
    setDisableChangeStatus(!isCheckboxSelected);
    setSelectAllClicked(true);
  };
  const _onRowChecked = row => {
    definitionData.data.map(item => {
      if (item.contractId === row.contractId) {
        item.isChecked = !item.isChecked;
      }
      return item;
    });
    const enableCS = definitionData.data.filter(
      item => item.isChecked === true
    );
    if (!isEmpty(enableCS)) {
      setDisableChangeStatus(false);
    } else {
      setDisableChangeStatus(true);
    }
    if (enableCS.length === definitionData.data.length) {
      setSelectAllClicked(true);
      setIsAllChecked(true);
    } else {
      setSelectAllClicked(false);
      setIsAllChecked(false);
    }
    setRowCheckboxClicked(true);
  };
  const onChangeStatusBtnClicked = () => {
    setShowBulkStatusUpdateModal(true);
  };
  const handleCancel = () => {
    setShowBulkStatusUpdateModal(false);
  };
  return (
    <div className="ca--main ca--target ca--flex-col ca-o-hidden ca--main-pad contract-admin">
      <div className="ca--header" data-test="target-main-header">
        <button
          type="button"
          onClick={() => addNew()}
          data-test="addNew"
          className="ca-add-btn"
        >
          <div className="grid-delete-icon">
            <img src={addNewIcon} alt="Add New" />
            <span className="ca-add-new-text">Add New</span>
          </div>
        </button>
      </div>
      <div>
        <CASearch
          onChange={_updateQueryParams}
          disableChangeStatus={
            !isEmpty(definitionData.data) ? disableChangeStatus : true
          }
          onChangeStatusBtnClicked={onChangeStatusBtnClicked}
        />
      </div>
      <CATableHeader
        data-test="CATableHeader"
        updateQueryParams={_updateQueryParams}
        definition={definitionData}
        toggleCheckboxState={_toggleCheckboxState}
        isCheckedFlag={isAllChecked}
      />
      <CATableBody
        data-test="CATableBody"
        definition={definitionData}
        updateQueryParams={_updateQueryParams}
        loadMore={loadItems}
        isAllChecked={isAllChecked}
        selectAllClicked={selectAllClicked}
        onRowChecked={_onRowChecked}
      />
      {showBulkStatusUpdateModal && (
        <BulkStatusUpdateModal
          showBulkStatusUpdateModal={showBulkStatusUpdateModal}
          onCancelClicked={handleCancel}
        />
      )}
    </div>
  );
};

ContractAdminView.propTypes = {
  definition: shape({
    loading: bool,
    error: bool,
    data: instanceOf(Array),
    query: shape({
      searchPhrase: string,
      sortBy: string,
      sortOrder: string,
      pageNumber: number,
    }),
  }),
  getDeDefinitions: func,
  addNewBtn: func,
  accountId: number,
};

ContractAdminView.defaultProps = {
  definition: {
    loading: true,
    error: false,
    data: [],
    query: {
      searchPhrase: '',
      sortColumn: 'updts',
      sortOrder: 'desc',
      pageNumber: 1,
      searchBy: 'account',
    },
  },
};

const mapStateToProps = ({ contractAdmin, account }) => {
  return {
    definition: {
      ...contractAdmin.definition,
      data: contractAdmin.definition.response.data,
    },
    accountId: account.activeAccountId,
  };
};

export default connect(mapStateToProps, {
  getDeDefinitions,
})(ContractAdminView);
